import { rightMenuClsPrefix } from "../../constants";

export const EVENT_SET_RIGHTMENU_VISIBLE = `${rightMenuClsPrefix}-set-rightmenu-visible`;
